<div id="Reader-selection-popup" class="modal-body read-device-selection ">
  <div class="row signifyBold20px detectTitle">Detect reader device</div>
  <div class="row signifyBold20px listOfReaderTitle">List of reader(s):</div>
  <form [formGroup]="readerDevicesForm">
    <div class="row custom-margin">
      <div class="row col-3 found-text" [ngClass]="{'disabledbutton': reader === 'simpleset'}">

        <div class="col-1"> <input class="simpleSetRadio" type="radio" value="simpleSet" name="readerType"
        formControlName="readerType"></div>
        <div class="col-2 signifyBold20px simpleset">SimpleSet</div>
      </div>
      <div class="col-4 remove-padding" [ngClass]="{'disabledbutton': reader === 'simpleset'}">
        <select id="simpleset-reader-select" class="select-modal-reader-select" (change)="onChange($event.target.selectedIndex)"
          formControlName="simpleSetDevices">
          <option id="simpleset-reader-option-select" value="select" disabled>Select</option>
          @for (name of readersInfo; track name; let i = $index) {
            <option [attr.id]="'simpleset-reader-option-' + i" [ngValue]="name.peripheralType+'-'+name.peripheralId">
            {{name.peripheralType}}-{{name.peripheralId}}</option>
          }
        </select>
      </div>
      <div class="col-3 connected">
        @if (readerConnected) {
          <img id="simpleset-reader-connected-icon" class="connected-icon" src="{{pathVal}}connected-original-icon.png" alt="Connected">
        }
        @if (!readerConnected) {
          <img id="simpleset-reader-disconnected-icon" class="connected-icon" src="{{pathVal}}disconnected-orginal-icon.png" alt="Connected">
        }

      </div>
    </div>
    @if (isDaliSupported) {
      <div class="row custom-margin">
        <div class="row col-3 found-text disabledbutton">
          <div class="col-1"> <input type="radio" class="" value="dali" name="readerType"
          formControlName="readerType"></div>
          <div class="col-2 dali signifyBold20px">Dali</div>
        </div>
        <div class="col-4 remove-padding disabledbutton">
          <select id="dali-reader-select" class="select-modal-reader-select dali-select" (change)="onChange($event.target.selectedIndex)"
            formControlName="daliDevices">
            <option id="dali-reader-option-select" value="select" disabled selected>Select</option>
            @for (name of nameR; track name; let i = $index) {
              <option [attr.id]="'dali-reader-option-' + i" [ngValue]="name">{{name.peripheralType}}</option>
            }
          </select>
        </div>
        <div class="col-3 connected">
          <img id="dali-reader-disconnected-icon" class="connected-icon " src="{{pathVal}}disconnected-orginal-icon.png" alt="Connected">
        </div>
      </div>
    }
    <div class="row btn-all">
      <div class=" col-3 refresh-btn">
        <button id="detect-reader-refresh-button" type="button" class="btn prev-refbtn" (click)="refreshReadersList()">Refresh</button>
      </div>
      <div class="col- 6 cancel-btn">
        <button id="detect-reader-ok-button" type="button" class="btn next-okbtn" (click)="selectreader()">OK</button>
        <button id="detect-reader-cancel-button" type="button" class="btn prev-refbtn" (click)="cancel()">Cancel</button>

      </div>

    </div>
  </form>
</div>
